import moment from "moment";

export function enumerateDaysBetweenDates(startDate, endDate) {
  var dates = [];

  var currDate = moment(moment(startDate).subtract(1, "days")).startOf("day");
  var lastDate = moment(moment(endDate).add(1, "days")).startOf("day");

  while (currDate.add(1, "days").diff(lastDate) < 0) {
    let item = {
      year: moment(currDate.toDate()).format("YYYY"),
      month: moment(currDate.toDate()).format("MM"),
      day: moment(currDate.toDate()).format("DD"),
    };
    dates.push(item);
  }
  return dates;
}

function groupedDays(messages) {
  return messages.reduce((acc, el, i) => {
    const messageDay = moment(el.createdAt).format('MM-DD-YYYY');
    if (acc[messageDay]) {
      return { ...acc, [messageDay]: acc[messageDay].concat([el]) };
    }
    return { ...acc, [messageDay]: [el] };
  }, {});
}

export function generateItems(messages, bottom) {
  const days = groupedDays(messages);
  const sortedDays = Object.keys(days).sort(
    (x, y) => moment(y, 'MM-DD-YYYY').unix() - moment(x, 'MM-DD-YYYY').unix()
  );
  const items = sortedDays.reduce((acc, date) => {
    const sortedMessages = days[date].sort(
      (x, y) => new Date(y.createdAt) - new Date(x.createdAt)
    );
    
    return acc.concat(bottom ? [...sortedMessages, { type: 'day', date: date, id: date }] : [{ type: 'day', date: date, id: date }, ...sortedMessages]);
  }, []);
  return items;
}

export function checkTodayYesterday(date) {
  let formet = moment(Date.now()).format('MM-DD-YYYY');
  const yesterday = moment(Date.now()).subtract(1, 'days').format('MM-DD-YYYY');
  if(date == formet) return "Today"
  else if (date == yesterday) return "Yesterday"
  else return date
}
